/**
 * Split a letter into sheets of paper (stationery). Words never sit on the
 * art: each sheet takes as much of the text as fits its writing area, and the
 * rest continues on the next sheet of the same design.
 *
 * Pure: the caller supplies `fits`, which measures (in the DOM) whether a run
 * of text fits one sheet's writing area. Text is split at whitespace, so a
 * word is never broken across sheets; one word too long for a whole sheet is
 * given a sheet of its own rather than looping.
 */
export function paginate(text: string, fits: (chunk: string) => boolean): string[] {
  const tokens = text.split(/(\s+)/).filter((t) => t.length > 0);
  const pages: string[] = [];
  let start = 0;
  while (start < tokens.length) {
    // Never begin a sheet with the space left over from the last one.
    while (start < tokens.length && /^\s+$/.test(tokens[start]!) && pages.length > 0) start++;
    if (start >= tokens.length) break;
    let lo = 1;
    let hi = tokens.length - start;
    let best = 0;
    while (lo <= hi) {
      const mid = (lo + hi) >> 1;
      if (fits(tokens.slice(start, start + mid).join(''))) {
        best = mid;
        lo = mid + 1;
      } else {
        hi = mid - 1;
      }
    }
    const take = Math.max(1, best);
    pages.push(tokens.slice(start, start + take).join('').replace(/\s+$/, ''));
    start += take;
  }
  return pages.length ? pages : [''];
}
